module.exports = __webpack_public_path__ + "ff8d44278122ed91df81d6298cb88602.png";